import { Body, Box, Container } from '@hover/blueprint';
import React, { FC } from 'react';
import ArrowButton from '../ui/ArrowButton';

interface IOption {
  description: string;
  downloadLink: string;
}

const DownloadButton: FC<IOption> = ({ description, downloadLink }) => (
  <Box
    width={{ base: '100%', desktop: '70%' }}
    flexDir="column"
    alignItems={{ base: 'center', desktop: 'flex-start' }}
  >
    <Body
      mt={{ base: 700, desktop: 100 }}
      mb={{ base: 700, desktop: 400 }}
      size={500}
      color="neutral.900"
      textAlign={{ base: 'center', desktop: 'left' }}
    >
      {description}
    </Body>
    <Container
      px={0}
      w="95%"
      mx="0"
      justifyContent={{ base: 'center', tablet: 'start' }}
    >
      <ArrowButton
        target="_blank"
        as="a"
        href={downloadLink}
        display="block"
        variant="outline"
        colorScheme="primary"
        type="button"
        w={{ base: '323px', tablet: '100%' }}
      >
        Download
      </ArrowButton>
    </Container>
  </Box>
);

export default DownloadButton;
